import { ADD_ORG, CLEAR_ORG } from './orgTypes';

const initialState = {
    currentOrg: null,
    loading: false
};

export default function orgReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_ORG:
            return { ...state, currentOrg: action.payload };
        case CLEAR_ORG:
            return initialState;
        default:
            return state;
    }
}
